//@ts-nocheck
import React from "react";
import { withRouter } from "react-router";
import withAlertBox from "../../../../components/src/withAlertBox.Web";
import withToast from "../../../../components/src/withSnackBar.Web";
import withLoader from "../../../../components/src/withLoader.Web";
import withDialog from "../../../../components/src/withDialog.web";
import withConfirmBox from "../../../../components/src/withConfirmBox.Web";
import QuestionCard from "./layout/QuestionCard.web";
import OptionList from "./layout/OptionList.web";
import StepFooter from "./layout/StepFooter.web";
import FirmQuestions from "./layout/FirmQuestions.web";

class CashFlowStep extends React.Component {
  async componentDidMount() {
    const stepNo = this.props.taxPayerType === "individual" ? "6.2" : "6.1";
    this.props.getQuestionAndOptionsByStepNo(stepNo);
  }
  render() {
    const selection = this.props.cashflowSelection || [];
    return (
      <>
        <QuestionCard
          title={this.props?.stepContent?.description}
          hint="Select any that apply"
        >
          <OptionList
            options={this.props?.stepContent?.options?.data}
            selected={selection}
            multiple
            onSelect={this.props.setCashflowSelection}
          />
        </QuestionCard>
        <FirmQuestions
          screen="cash_flow"
          taxPayerType={this.props.taxPayerType}
          questions={this.props.firmQuestions}
          answers={this.props.firmAnswers}
          onChange={this.props.setFirmAnswer}
        />
        <StepFooter
          onBack={this.props.handleBack}
          onNext={this.props.handleNext}
          nextDisabled={selection.length === 0}
        />
      </>
    );
  }
}
const CashFlowStepWithRouter = withRouter(CashFlowStep);
const CashFlowStepAlertBox = withAlertBox(CashFlowStepWithRouter);
const CashFlowStepLoader = withLoader(CashFlowStepAlertBox);
const CashFlowStepToast = withToast(CashFlowStepLoader);
const CashFlowStepWithDialog = withDialog(CashFlowStepToast);

export default withConfirmBox(CashFlowStepWithDialog);
